import { Dropdown, Space } from "antd";
import React, { useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import { geTdayToPassSunday, getMonthFilter, getSaturdayWeekAgo, getSundayWeekAgo, getTodayFilter, getWeekFilter, getYearFilter, setDateFormat } from "../../helpers/dateHelpers";

const items = [
    {
        key: "1",
        label: <p className="text-black text-base">Hoy</p>,
        beforeText: "Respecto a ayer",
        startDate: setDateFormat(0, 0),
        endDate: setDateFormat(0, 23),
        jumps: 1,
        getFilter: () => getTodayFilter()
    },
    {
        key: "2",
        label: <p className="text-black text-base">Ayer</p>,
        beforeText: "Respecto a antier",
        startDate: setDateFormat(1, 0),
        endDate: setDateFormat(1, 23),
        jumps: 1,
        getFilter: () => getTodayFilter(true)
    },
    {
        key: "3",
        label: <p className="text-black text-base">Esta semana</p>,
        beforeText: "Respecto a la semana anterior",
        startDate: geTdayToPassSunday(),
        endDate: setDateFormat(0, 23),
        jumps: 1,
        getFilter: () => getWeekFilter()
    },
    {
        key: "4",
        label: <p className="text-black text-base">Semana anterior</p>,
        beforeText: "Respecto a hace dos semanas",
        startDate: getSundayWeekAgo(),
        endDate: getSaturdayWeekAgo(),
        jumps: 1,
        getFilter: () => getWeekFilter(true)

    },
    {
        key: "5",
        label: <p className="text-black text-base">Este mes</p>,
        beforeText: "Respecto al mes anterior",
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        endDate: setDateFormat(0, 23),
        jumps: 5,
        getFilter: () => getMonthFilter()
    },
    {
        key: "6",
        label: <p className="text-black text-base">Mes anterior</p>,
        beforeText: "Respecto a hace dos meses",
        startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        jumps: 5,
        getFilter: () => getMonthFilter(true)
    },
    {
        key: "7",
        label: <p className="text-black text-base">Este año</p>,
        beforeText: "Respecto al año anterior",
        startDate: new Date(new Date().getFullYear(), 0, 1),
        endDate: setDateFormat(0, 23),
        jumps: 24,
        getFilter: () => getYearFilter()
    },
];

export const DropDownFilterDates = ({ callBack }) => {
    const [selected, setSelected] = useState(items[6].label);

    const onClick = ({ key }) => {
        const selected = items.find((item) => item.key === key);
        setSelected(selected.label);
        const { start, end } = selected.getFilter()
        callBack(selected.startDate, selected.endDate, selected.jumps, { startDate: start, endDate: end }, selected.beforeText);
    };

    return (
        <Dropdown
            className="cursor-pointer "
            menu={{
                items,
                onClick,
            }}
        >
            <div onClick={(e) => e.preventDefault()}>
                <Space >

                    {selected}
                    <DownOutlined />
                </Space>
            </div>
        </Dropdown>
    );
};

export default DropDownFilterDates;
